import { render, staticRenderFns } from "./MatterConsultingForm.vue?vue&type=template&id=02257cea&"
import script from "./MatterConsultingForm.vue?vue&type=script&lang=js&"
export * from "./MatterConsultingForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterConsultingForm.vue?vue&type=style&index=0&id=02257cea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports